var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#008C15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6 12.6001C13.097 12.6001 13.5 13.003 13.5 13.5001V24.3001H22.5V13.5001C22.5 13.003 22.9029 12.6001 23.4 12.6001C23.897 12.6001 24.3 13.003 24.3 13.5001V24.3001C24.3 25.2942 23.4941 26.1001 22.5 26.1001H13.5C12.5058 26.1001 11.7 25.2942 11.7 24.3001V13.5001C11.7 13.003 12.1029 12.6001 12.6 12.6001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8999 12.6C9.8999 12.1029 10.3028 11.7 10.7999 11.7L25.1999 11.7C25.697 11.7 26.0999 12.1029 26.0999 12.6C26.0999 13.097 25.697 13.5 25.1999 13.5L10.7999 13.5C10.3028 13.5 9.8999 13.097 9.8999 12.6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 10.8C13.5 9.80589 14.3059 9 15.3 9H20.7C21.6941 9 22.5 9.80589 22.5 10.8V12.6C22.5 13.0971 22.0971 13.5 21.6 13.5C21.1029 13.5 20.7 13.0971 20.7 12.6V10.8H15.3V12.6C15.3 13.0971 14.8971 13.5 14.4 13.5C13.9029 13.5 13.5 13.0971 13.5 12.6V10.8Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFull);
export default __webpack_public_path__ + "static/media/DeleteFull.9df9b49d911d22e9819e07ab74e16041.svg";
export { ForwardRef as ReactComponent };